// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"92b433d1","455":"98a53fb9","977":"d1c9a397"}[chunkId] + ".chunk.js";
};